import { createSelector } from 'reselect';
import { splashImages } from './assets';
import { MODULE_NAME } from './constants';

export const getModuleState = (state) => state.getIn(['modules', MODULE_NAME]);

export const getDynatraceID = (state) => state.getIn(['config', 'dynatraceId']);

export const getCoreState = (state) => getModuleState(state).getIn(['core']);
export const getProducts = (state) => state.getIn(['modules', MODULE_NAME, 'products']);
export const getTargetAllowList = (state) => state.getIn(['config', 'targetAllowList']);
export const isPureRoute = createSelector(getCoreState, (state) => !!state.getIn(['isPureRoute']));
export const getFdicBannerList = (state) => state.getIn(['config', 'showFdicList']);

export const isRedirecting = createSelector(
  [
    (state) => state.getIn(['redirection', 'redirectionInFlight']),
    (state) => getCoreState(state).getIn(['redirection', 'from']),
    (state) => getCoreState(state).getIn(['redirection', 'to']),
  ],
  (redirectionInFlight, from, to) => redirectionInFlight || from !== to
);

export const getLoginUrl = createSelector(
  [(state) => state.getIn(['intl', 'activeLocale'])],
  (locale) => `/${locale.toLowerCase()}/account/login`
);

export const getOneIdentityCorrelationId = createSelector(
  getCoreState, (core) => core.getIn(['oneIdentityCorrelationId'])
);

export const getImagePath = createSelector(
  [
    (state) => state.getIn(['config', 'holocronModulesPath']),
    (state) => state.getIn(['holocron', 'moduleVersions', MODULE_NAME]),
  ],
  (holocronModulesPath, version) => `${holocronModulesPath}/${MODULE_NAME}/${version}/images`
);

const getSplashImageLinks = createSelector(
  getImagePath,
  (imagePath) => ({
    imagePath,
    splashImageLinks: splashImages.map(({ image, media }) => ({
      rel: 'apple-touch-startup-image',
      href: `${imagePath}/${image}`,
      media,
    })),
  })
);

export const getHelmetLinks = createSelector(
  getSplashImageLinks,
  ({ imagePath, splashImageLinks }) => [
    { rel: 'apple-touch-icon', sizes: '192x192', href: `${imagePath}/icon-192.png` },
    { rel: 'icon', href: 'https://www.americanexpress.com/favicon.ico' },
    ...splashImageLinks,
  ]
);

export const isAuthenticated = (state) => getModuleState(state).getIn(['auth', 'session'], false);
export const isLogSuccess = (state) => state.getIn(['config', 'fetchLogging', MODULE_NAME]);
export const getFaasUrl = (state) => state.getIn(['config', 'faasApiUrl'], '');
export const getActiveLocale = (state) => state.getIn(['intl', 'activeLocale']);

// eslint-disable-next-line max-len -- selector is long
export const getShowIdentityUiPassword = (state) => state.getIn(['intl', 'languagePacks', getActiveLocale(state), MODULE_NAME, 'data', 'showIdentityUiPassword']);
// eslint-disable-next-line max-len -- selector is long
export const getShowIdentityUiTwoStepManage = (state) => state.getIn(['intl', 'languagePacks', getActiveLocale(state), MODULE_NAME, 'data', 'showIdentityUiTwoStepManage'], false);
// eslint-disable-next-line max-len -- selector is long
export const getShowIdentityUiManagementCenter = (state) => state.getIn(['intl', 'languagePacks', getActiveLocale(state), MODULE_NAME, 'data', 'showIdentityUiManagementCenter']);
// eslint-disable-next-line max-len -- selector is long
export const getShowIdentityUiTwoStepVerification = (state) => state.getIn(['intl', 'languagePacks', getActiveLocale(state), MODULE_NAME, 'data', 'showIdentityUiTwoStepVerification']);

// eslint-disable-next-line max-len -- selector is long
export const getHasPasskeysEnabled = (state) => state.getIn(['intl', 'languagePacks', getActiveLocale(state), MODULE_NAME, 'data', 'hasPasskeysEnabled'], false);
